import { CALL_API } from '../../../middlewares/api';

import { REQUEST_LOGIN, SUCCESS_LOGIN, FAILURE_LOGIN } from './constants';

import { updateInfos } from '../../account/actions';
import { forceFetchPartners } from '../../partner/actions';

/**
 * Execute un appel AJAX vers le serveur pour faire une demande de login
 * Envoie au serveur le username et le password du membre
 * @param {*JSON} creds les identifiants de connexion du membre, {username: 'michel', password: 'azerty'}
 * @param {function} callback fonction executé lorsque le login à réussit
 */

export const loginUser = (creds, callback) => {
    return {
        [CALL_API]: {
            endpoint: '/auth/login',
            types: [REQUEST_LOGIN, SUCCESS_LOGIN, FAILURE_LOGIN],
            body: creds,
            successCallback: (response, dispatch) => {
                dispatch(updateInfos(response.payload.user));
                dispatch(forceFetchPartners());
                if (callback) {
                    callback();
                }
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/authentication/login/actions.js